<template>
    <div>
    <h3 class="is-size-3">Tipos de identificación</h3>
        <p> <code>GET https://utils.blcp.mx/api/tipo-identificacion/{idCode?}</code> </p>
        <br>
        <h5 class="is-size-6">El endpoint tiene un parametro opcional:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>idCode</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato (Ej. 1)</li>
                    </ul>
                </li>
            </ul>
        </div>
        <br/>
        <h5 class="is-size-6">El endpoint recibe un token de seguridad en el header:</h5> 
        <pre>
        <code>headers: 
        { 
            "Authentication":"Bearer {TOKEN}",
        }</code>
        </pre>
        <br>
        <h5 class="is-size-6">Respuesta:</h5> 
        <pre>
        <code>
            [
                {
                    "id": 1,
                    "descripcion": "INE"
                },
                {
                    "id": 2,
                    "descripcion": "PASAPORTE"
                },
                {
                    "id": 3,
                    "descripcion": "FORMA MIGRATORIA"
                },
                {
                    "id": 4,
                    "descripcion": "CÉDULA PROFESIONAL"
                },
                {
                    "id": 5,
                    "descripcion": "CARTILLA MILITAR"
                }
            ]
        </code>
        </pre>
        <hr />
       
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>

</style>